<div class="db-remove-demo">
  <div class="db-remove-demo__header" [innerHTML]="'text_removeDemoWebsite' | dbText"></div>
  <div class="db-remove-demo__message">
    <p class="mt15" [innerHTML]="'text_removeDemoWebsiteDesc' | dbText"></p>
    <div class="db-remove-demo__buttons-wrap mt30">
      <a class="ds-btn" (click)="close()"><span>{{'text_cancel' | dbText | lowerCaseSpecificWords}}</span></a>
      <a class="ds-btn-red" (click)="removeDemoWebsiteRequest()">
        <span *ngIf="!loading">{{'text_removeDemoWebsiteBtn' | dbText | lowerCaseSpecificWords}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</div>
